import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type ElementLoaderClasses = 'loader';

const elementLoaderStyles = makeStyles<ISpcTheme, ElementLoaderClasses>(
  () => ({
    loader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 auto',
    },
  }),
  { name: 'Customise_ElementLoader' },
);

export default elementLoaderStyles;
